import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest, call } from 'redux-saga/effects'
import { getRequest, makeGetRequest, makePutRequest, makePostRequest } from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'
import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import { toContactFormData } from './serializers'
import { serializeNullToEmptyString } from 'utils/helpers'

function* fetchContactsRowData() {
  try {
    const url = '/v1/contacts'
    const rowData = yield makeGetRequest(url)
    yield put({
      type: ACT.CONTACTS_ROW_DATA_FETCH_SUCCESS,
      payload: {
        rowData: serializeNullToEmptyString(rowData)
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Contacts',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchContactBusinessCardData(action) {
  try {
    const { id } = action.payload
    const url = `/v1/contacts/${id}`
    const contact = yield call(getRequest, url)
    yield put({
      type: ACT.CONTACT_DETAIL_FETCH_SUCCESS,
      payload: {
        contact
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Contact Business Card',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* updateContactDetail(action) {
  const { contact } = action.payload

  try {
    const url = `/v1/contacts/${contact.id}`
    yield makePutRequest(url, {
      ...contact
    })

    yield put({
      type: ACT.CONTACTS_DETAIL_UPDATE_SUCCESS,
      payload: { contact }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue updating Contact',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* fetchEmployees() {
  try {
    const url = '/v1/users'
    const employees = yield makeGetRequest(url)
    yield put({
      type: ACT.CONTACTS_EMPLOYEES_FETCH_SUCCESS,
      payload: {
        employees: employees.content
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Employees',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* createContact(action) {
  const { contact, fileInfo } = action.payload
  try {
    const url = '/v1/contacts'
    const response = yield makePostRequest(url, toContactFormData(contact, fileInfo))

    yield put({
      type: ACT.CONTACT_CREATE_SUCCESS,
      payload: {
        contact: response
      }
    })

    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'Contact created successfully',
        level: 'success'
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue creating Contact',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const contactsSagas = [
  takeLatest(ACT.CONTACTS_ROW_DATA_FETCH_REQUESTED, fetchContactsRowData),
  takeLatest(ACT.CONTACT_DETAIL_FETCH_REQUESTED, fetchContactBusinessCardData),
  takeLatest(ACT.CONTACTS_DETAIL_UPDATE_REQUESTED, updateContactDetail),
  takeLatest(ACT.CONTACTS_EMPLOYEES_FETCH_REQUESTED, fetchEmployees),
  takeLatest(ACT.CONTACT_CREATE_REQUESTED, createContact)
]

export default contactsSagas
